'use strict';

const BrowserUtils = {

    /**
     * Retrieve is FF browser.
     * @returns {boolean}
     */
    isFF() {
        return !!navigator.userAgent.match(/firefox/i);
    },

    /**
     * Detects if it's a mobile browser
     * @return {Boolean} true if it's a mobile browser
     */
    isMobile() {
        return /iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent);
    },

    /**
     * Detects if it's a mobile browser
     * @return {Boolean} true if it's a mobile browser
     */
    isMobileNonIPad() {
        return /iPhone|Android|BlackBerry/.test(navigator.userAgent);
    },

    isIpad() {
        return !!navigator.userAgent.match(/IPad/ig);
    },

    /**
     * Detects if it's a mobile browser
     * @return {Boolean} true if it's a mobile browser
     */
    isMobileNonCareIPad() {
        return /iPhone|iPod|Android|BlackBerry/.test(navigator.userAgent);
    },

    changeCursorWait() {
        document.body.style.cursor = 'wait';
    },

    changeCursorDefault() {
        document.body.style.cursor = 'default';
    }
};

module.exports = BrowserUtils;



/** WEBPACK FOOTER **
 ** ./src/utils/BrowserUtils.js
 **/